import { Injectable } from '@angular/core';

import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderGroupIdService extends DataService<string> { }
